import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { EnumConfigOption } from '@/common';
import { useLocalObservable } from 'mobx-react-lite';
import { App, Modal, Button, Row, Col, List } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import DraggableItem from './DraggableItem';
import './EnumConfig.css';
import { globalApi } from '@/common/ctrl';

export type Props = {
  visible: boolean;
  options: EnumConfigOption[];
  type: number;
  onClose: () => void;
};

type Store = {
  configOptions: EnumConfigOption[];
};

const EnumConfig: React.FC<Props> = ({ visible, options = [], type, onClose }) => {
  const { message } = App.useApp();
  const store = useLocalObservable<Store>(() => ({
    configOptions: []
  }));

  const checkEditing = ():boolean =>{
    let isEditing : boolean = false;
    store.configOptions.forEach((item)=>{
      if(item.id == null){
        isEditing = true;
      }
    })
    return isEditing;
  } 

  useEffect(() => {
    if (visible && !checkEditing()) {
      store.configOptions = options.map(option => ({ ...option }));
    }
  }, [visible, options]); 

  const moveCard = (dragIndex: number, hoverIndex: number) => {
    const updatedOptions = [...store.configOptions];
    const [draggedItem] = updatedOptions.splice(dragIndex, 1);
    updatedOptions.splice(hoverIndex, 0, draggedItem);
    store.configOptions = updatedOptions;
  };

  const removeOptionAt = (index: number) => {
    const updatedOptions = [...store.configOptions];
    updatedOptions.splice(index, 1);
    store.configOptions = updatedOptions;
  };

 

  const addOption = () => {

    let isEditing : boolean = checkEditing(); 
    if(isEditing){
      message.warning("存在正在编辑中的配置项，请先保存！");
      return;
    }

    const newOption: EnumConfigOption = {
      id: null,
      name: '',
      type,
      orderNum: 0,
      deleteFlag: 0,
    };
    store.configOptions.push(newOption);
    store.configOptions = store.configOptions.slice();
  };

  const saveChanges = async () => {
    if (checkEditing()) {
      message.warning('存在正在编辑中的配置项，请先保存！');
      return;
    }
    const payload = store.configOptions.map((item, index) => ({
      ...item,
      type,
      orderNum: index + 1,
    }));
    const updateResult = await globalApi.updateEnumConfigByType(type, payload);
    if (updateResult) {
      message.info('配置项更新成功！');
      onClose();
    } else {
      message.error('配置项更新失败！');
    }
  };

  return (
    <Modal open={visible} onCancel={onClose} onOk={saveChanges} className='enum-config' title="选项配置和顺序设置">
      <DndProvider backend={HTML5Backend}>
        <Row gutter={16}>
          <Col span={24}>
            <List
              itemLayout="horizontal"
              dataSource={store.configOptions}
              renderItem={(item, index) => (
                <DraggableItem
                  key={item.id ?? `new-${index}`}
                  item={item}
                  index={index}
                  moveCard={moveCard}
                  onRemove={removeOptionAt}
                />
              )}
            />
          </Col>
        </Row>
        <Row justify='space-between'>
          <Col span={10}>
            <Button type="text" className='add-config-button' onClick={addOption} icon={<PlusOutlined />} block>
              添加配置项
            </Button>
          </Col>
          <Col span={10} style={{textAlign:'right'}}>
             <span className='drag-hint'>按住鼠标拖动进行排序</span>
          </Col>
        </Row>
      </DndProvider>
    </Modal>
  );
};

export default observer(EnumConfig);